import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { List, Map } from 'immutable'
import { isGenreInterview } from 'services/content'

/**
 * Display guests for genre Interview
 * @param {Object} props - The props
 * @param {Map} props.data - The content data
 * @param {Map} props.staticText - The static text
 * @param {Boolean} props.useGraphQL - Whether or not the data is GraphQL data
 * @param {Map} props.featuredEpisode - The featured episode if it is a series
 * @param {Boolean} props.featuredEpisodeInProgress - If there is a featured episode in progress
 * @returns {JSX.Element} Tile tags component
 */
function TileV2Guests (props) {
  const {
    data,
    staticText,
    useGraphQL,
    featuredEpisode,
    featuredEpisodeInProgress,
  } = props
  const tags = List.isList(data.get('references')) ? data.get('references', List()) : List()
  const showGuest = isGenreInterview({ tags })
  let guestData = data

  // If this is old / non-graphql data
  if (!useGraphQL && featuredEpisodeInProgress) {
    guestData = featuredEpisode.get('data', Map())
  }

  // If this is graphql data
  if (useGraphQL && featuredEpisodeInProgress) {
    guestData = featuredEpisode
  }

  const guests = !useGraphQL ? guestData.get('guest') : guestData.get('cast')

  if (!showGuest) {
    return null
  }

  if (!guests) {
    return null
  }

  return (
    <div className="tile-v2__guests">
      <span className="tile-v2__guest-label">
        {`${staticText.get('with')} `}
      </span>
      <span className="tile-v2__guest-text">
        {guests}
      </span>
    </div>
  )
}

TileV2Guests.defaultProps = {
  useGraphQL: true,
}

TileV2Guests.propTypes = {
  useGraphQL: PropTypes.bool,
  featuredEpisode: ImmutablePropTypes.map,
  featuredEpisodeInProgress: PropTypes.bool,
}

export default TileV2Guests
